import keycode from 'keycode';
import { Component, Vue } from 'vue-property-decorator';
import { ownerDocument } from '../../lib';
import ClList from '../ClList';

@Component({
  components: {
    ClList
  }
})
export default class ClMenuList extends ClList {
  public handleKeyDown(event: KeyboardEvent) {
    const listRef: Vue = this.$refs.list as Vue;
    const listEl: Element = listRef.$el;
    const key: string = keycode(event);
    const currentFocus: Element | null = ownerDocument(listEl).activeElement;
    let target: Element | null = null;

    if (
      (key === 'up' || key === 'down') &&
      (!currentFocus || (currentFocus && !listEl.contains(currentFocus)))
    ) {
      target = listEl.firstChild as Element;
    } else if (currentFocus && key === 'down') {
      event.preventDefault();
      target = currentFocus.nextElementSibling as Element;
    } else if (currentFocus && key === 'up') {
      event.preventDefault();
      target = currentFocus.previousElementSibling as Element;
    }

    if (target) {
      (target as HTMLElement).focus();
    }

    this.$emit('keydown', event, key);
  }
}
